import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { contentMessages } from 'utils/constants/ui'

dayjs.extend(utc)
dayjs.extend(timezone)

// Format the date time
const formatDateTime = (
  dateTime: string,
  inputTimezone: string = 'Africa/Abidjan',
  format: string = 'DD MMM, YYYY hh:mm:ss A'
) => {
  if (!dateTime || dateTime === contentMessages.NO_DATA)
    return contentMessages.NO_DATA
  const dateTimeInUTC = dayjs.utc(dateTime)
  return dayjs(dateTimeInUTC).tz(inputTimezone).format(format)
}

export default formatDateTime
